const actions = {
    FETCH_EMAIL_GROUPS: 'FETCH_EMAIL_GROUPS',
    FETCH_EMAIL_GROUP: 'FETCH_EMAIL_GROUP',
    RESET_EMAIL_GROUP_FORM: 'RESET_EMAIL_GROUP_FORM',

    fetchEmailGroupsAction: (data) => {
        return {
            type: actions.FETCH_EMAIL_GROUPS,
            data: data
        };
    },
    fetchEmailGroupAction: (data) => {
        return {
            type: actions.FETCH_EMAIL_GROUP,
            data: data
        };
    },
    resetEmailGroupFormAction: () => {
        return {
            type: actions.RESET_EMAIL_GROUP_FORM,
            data: null
        };
    },
};

export default actions;